/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Content/SyncPatients/Content/PatientNotFoundCard/ReplacePatient/Content/SearchResult/Empty"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="No patient found."
/>
{children}
</React.Fragment>)
}